import { useTranslation } from 'react-i18next';
import { resources } from '../../../../../resources/resources';
import { EmployeeDetailsTabs } from '../types';

interface EmployeeDetailsTabNavProps {
  activeTab: EmployeeDetailsTabs;
  onTabChange: (tab: EmployeeDetailsTabs) => void;
}

export default function EmployeeDetailsTabNav(
  props: Readonly<EmployeeDetailsTabNavProps>,
) {
  const { activeTab, onTabChange } = props;
  const { t: translate } = useTranslation();
  return (
    <ul className="acc-tabs">
      <li
        onClick={() => onTabChange(EmployeeDetailsTabs.GeneralTab)}
        className={
          activeTab === EmployeeDetailsTabs.GeneralTab
            ? 'acc-tab-active'
            : undefined
        }
      >
        {translate(resources.admin.employees.details.tabs.general)}
      </li>
      <li
        onClick={() => onTabChange(EmployeeDetailsTabs.TransactionTab)}
        className={
          activeTab === EmployeeDetailsTabs.TransactionTab
            ? 'acc-tab-active'
            : undefined
        }
      >
        {translate(resources.admin.employees.details.tabs.trasactions)}
      </li>
      <li
        onClick={() => onTabChange(EmployeeDetailsTabs.StateHistoryTab)}
        className={
          activeTab === EmployeeDetailsTabs.StateHistoryTab
            ? 'acc-tab-active'
            : undefined
        }
      >
        {translate(resources.admin.employees.details.tabs.stateHistory)}
      </li>
    </ul>
  );
}
